import { render, staticRenderFns } from "./ChatVideoPlayer.vue?vue&type=template&id=35b92056&scoped=true&"
import script from "./ChatVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./ChatVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ChatVideoPlayer.vue?vue&type=style&index=0&id=35b92056&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b92056",
  null
  
)

export default component.exports